import { useState } from 'react'

import { AddButton } from '#app/routes/mocra+/_form+/components/add-button.tsx'
import { ProductOverlay } from '#app/routes/mocra+/_form+/components/products/overlay.tsx'
import {
	createProductDraft,
	type ProductDraft,
} from '#app/routes/mocra+/_form+/components/products/types.ts'

type Props = {
	readonly onSubmit: (draft: ProductDraft) => void
	readonly defaultValue?: ProductDraft
	readonly triggerLabel?: string
	readonly disabled?: boolean
	readonly className?: string
}

export function ProductAdd({
	onSubmit,
	defaultValue,
	triggerLabel,
	disabled,
	className,
}: Props) {
	const [open, setOpen] = useState(false)

	const handleSubmit = (draft: ProductDraft) => {
		onSubmit(draft)
		setOpen(false)
	}

	return (
		<>
			<AddButton
				onClick={() => setOpen(true)}
				disabled={disabled}
				className={className}
			>
				{triggerLabel ?? 'Add product'}
			</AddButton>
			<ProductOverlay
				mode="add"
				open={open}
				onOpenChange={setOpen}
				onSubmit={handleSubmit}
				initialValue={defaultValue ?? createProductDraft()}
				onClosed={() => setOpen(false)}
			/>
		</>
	)
}
